<template>
    <b-td style="width: 150px ;">
        <vue-bootstrap-typeahead
                :data="countries"
                :placeholder="placeholder"
                :serializer="item => item.name"
                id="countrySearch"
                v-model="query"
        >
            <template slot="suggestion" slot-scope="{ data, htmlText }">
                <img
                        :src="
                        require('@/assets/images/flags/' +
                          data.code.toLowerCase() +
                          '.svg')
                      "
                        style="margin-right:5px"
                        width="20"
                />
                <span v-html="htmlText"></span>
            </template>
        </vue-bootstrap-typeahead>
    </b-td>
</template>

<script>
    export default {
        name: 'TableFilterTypeahead',
        props: {
            placeholder: String,
            name: String,
            country: Array
        },
        data() {
            return {
                query: 'country',
                countries: this.country,
                value: ''
            };
        },
        updated() {
            this.value = this.countries.find(record => record.name == this.query);
            this.$emit('method', 'country.code', this.value ? this.value.code : null);
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
